import { match } from 'ts-pattern';
import type { DataResource } from './types';

/** Which identifier applies depends on the resource. */
export type DataSelection = {
  resource: DataResource;
  selectedId?: string;
  labIdentifier?: string;
  /** A lab category's level-2 view fills the detail column on its own, with no single lab chosen. */
  labGroup?: string;
  vitalIdentifier?: string;
  surveyIdentifier?: string;
};

/**
 * Whether the detail column has a record to show. `DataTab` needs it too: an empty column has nothing to
 * scroll, and padding it draws the empty panel's edge across the column.
 */
export const hasDataSelection = ({
  resource,
  selectedId,
  labIdentifier,
  labGroup,
  vitalIdentifier,
  surveyIdentifier,
}: DataSelection): boolean =>
  match(resource)
    .with('labs', () => !!labIdentifier || !!labGroup)
    .with('vitals', () => !!vitalIdentifier)
    .with('surveys', () => !!surveyIdentifier)
    .otherwise(() => !!selectedId);
